import React, { useState, useContext, useEffect, Fragment } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import AppContext from 'context/Context';
import { RESPONSE_CODE } from 'types/const';
import { useConfirmModalState } from 'global/confirmModalState';

// api
import { mthVessMapList } from 'api/haccp/mothershipInfo/mothershipInfoApi';

function RegistModal(props) {
  const {
    config: { isDark }
  } = useContext(AppContext);

  /* porps */
  const {
    registModalShow,
    setRegistModalShow,
    modalRegistConfirm,
    motherShipInfo,
    mappingSeq
  } = props || {};

  const { pltCd, pltNm, matnr, licha } = motherShipInfo || {};

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [list, setList] = useState([]);

  /* event */
  const confirm = () => {
    const checkList = list?.filter(e => e.check === 1);
    if (Array.isArray(checkList) && !checkList.length) return;
    modalRegistConfirm(checkList);
  };

  const onSearch = async () => {
    const lichaData = licha?.substring(0, 3).trim();

    const requestBody = {
      pltCd: pltCd,
      sampleCd: matnr, // 원료크드
      cshipNm: lichaData, // 모선명
      mthvessMapYn: 'N'
    };

    const response = await mthVessMapList(requestBody);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    // 검사의뢰일 기준 내림차순 정렬
    setList(
      list
        ?.map(e => {
          e.check = 2;
          if (mappingSeq === e.seq) {
            e.check = 1;
          }
          return e;
        })
        ?.sort((a, b) => new Date(b.inspReqDt) - new Date(a.inspReqDt))
    );
  };

  const updateFieldChanged = (e, index) => {
    // 상세페이지 모선명
    const lichaData = licha?.trim();
    // 검사결과 모선명
    const cshipNm = list[index]?.cshipNm?.trim();

    /**
     * 모선명이 일치하지 않는 경우
     */
    if (lichaData !== cshipNm) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '모선명이 일치하지 않습니다. \n 검사결과를 등록하시겠습니까?',
        isCancelBtn: true,
        isConfirmBtn: true,
        onConfirm: () => {
          onHandleConfirm(e, index);
        }
      });
      return;
    }

    onHandleConfirm(e, index);
  };

  /* 검사결과 등록 */
  const onHandleConfirm = (e, index) => {
    const { name, value } = e.target || {};

    const newList = [...list]?.map(e => {
      e.check = 2;
      return e;
    });

    newList[index] = { ...newList[index], [name]: Number(value) };
    setList(newList);
  };

  /* watch */
  useEffect(() => {
    onSearch();
  }, []);

  return (
    <Modal
      show={registModalShow}
      onHide={() => setRegistModalShow(false)}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : undefined}
        className="px-card border-bottom-0"
      >
        <Modal.Title>검사결과 선택</Modal.Title>
      </Modal.Header>
      <Modal.Body className="scrollbar max-vh-75">
        <p className="fs--1">검사결과를 1개만 선택해주세요.</p>
        <div className="max-vh-50 scrollbar">
          <Table
            bordered
            className="fs--1 text-center"
            style={{ tableLayout: 'fixed' }}
          >
            <thead
              className="bg-200 text-700 align-middle border-300"
              style={{ position: 'sticky', top: 0 }}
            >
              <tr>
                <th></th>
                <th className="text-nowrap">검사결과 Type</th>
                <th className="text-nowrap">공장</th>
                <th className="text-nowrap">원료코드</th>
                <th className="text-nowrap">원료명</th>
                <th className="text-nowrap">모선명</th>
                <th className="text-nowrap">원산지명</th>
                <th className="text-nowrap">검사의뢰일</th>
                <th className="text-nowrap">검사결과 등록일</th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {list?.map(
                (
                  {
                    inspResultTypeNm,
                    sampleCd,
                    sampleNm,
                    cshipNm,
                    coriNm,
                    inspReqDt,
                    inspCmtDt,
                    inspResultIrdntList,
                    check
                  },
                  index
                ) => (
                  <Fragment key={index}>
                    <tr>
                      <td>
                        <Form.Check
                          type="radio"
                          id={`result${index}`}
                          name="check"
                          checked={check === 1}
                          value={1}
                          onChange={e => updateFieldChanged(e, index)}
                        />
                      </td>
                      <td>{inspResultTypeNm || '-'}</td>
                      <td>{pltNm || '-'}</td>
                      <td>{sampleCd || '-'}</td>
                      <td>{sampleNm || '-'}</td>
                      <td>{cshipNm || '-'}</td>
                      <td>{coriNm || '-'}</td>
                      <td>{inspReqDt || '-'}</td>
                      <td>{inspCmtDt || '-'}</td>
                    </tr>
                    {/* 검사결과 선택 */}
                    {check === 1 && (
                      <tr>
                        <td colSpan={9} className="text-start">
                          <p className="fs--1">● 검사결과</p>
                          <div className="scrollbar">
                            <Table bordered className="fs--1 text-center mb-0">
                              <thead className="bg-200 text-700 align-middle border-300">
                                <tr>
                                  <th className="text-nowrap py-2 px-3">
                                    검사항목
                                  </th>
                                  {inspResultIrdntList?.map(
                                    (
                                      { inspIrdntNm, inspResultIrdntNm },
                                      index
                                    ) => (
                                      <Fragment key={index}>
                                        <th className="text-nowrap py-2 px-3">
                                          {inspIrdntNm || inspResultIrdntNm}
                                        </th>
                                      </Fragment>
                                    )
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th className="text-nowrap py-2 px-3">
                                    검사결과
                                  </th>
                                  {inspResultIrdntList?.map(
                                    ({ inspResultVal }, index) => (
                                      <Fragment key={index}>
                                        <th className="py-2 px-3">
                                          {inspResultVal || '-'}
                                        </th>
                                      </Fragment>
                                    )
                                  )}
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                )
              )}
              {list.length < 1 && (
                <tr>
                  <td colSpan={8} className="w-auto">
                    검사결과 정보가 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer className="px-card border-top-0 align-items-center justify-content-center">
        <Button variant="secondary" onClick={() => setRegistModalShow(false)}>
          취소
        </Button>
        {list.length > 0 && <Button onClick={() => confirm()}>확인</Button>}
      </Modal.Footer>
    </Modal>
  );
}

export default RegistModal;
